import { GENERATION_JOB_SESSION_KEY } from "./generationJobConstants";

export function readTrackedJobIds() {
  try {
    const raw = sessionStorage.getItem(GENERATION_JOB_SESSION_KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch {
    return [];
  }
}

export function writeTrackedJobIds(jobIds) {
  try {
    const unique = [...new Set(jobIds.filter(Boolean))];
    sessionStorage.setItem(GENERATION_JOB_SESSION_KEY, JSON.stringify(unique));
  } catch {
    // ignore storage failures
  }
}

export function addTrackedJobId(jobId) {
  if (!jobId) {
    return;
  }
  writeTrackedJobIds([...readTrackedJobIds(), jobId]);
}

export function removeTrackedJobId(jobId) {
  writeTrackedJobIds(readTrackedJobIds().filter((id) => id !== jobId));
}

const DISMISSED_COMPLETION_JOBS_KEY = "tema_dismissed_completion_jobs";

export function readDismissedCompletionJobIds() {
  try {
    const raw = sessionStorage.getItem(DISMISSED_COMPLETION_JOBS_KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch {
    return [];
  }
}

export function addDismissedCompletionJobId(jobId) {
  if (!jobId) {
    return;
  }
  const next = [...new Set([...readDismissedCompletionJobIds(), jobId])];
  try {
    sessionStorage.setItem(DISMISSED_COMPLETION_JOBS_KEY, JSON.stringify(next));
  } catch {
    // ignore storage failures
  }
}

export function hasDismissedCompletionJobId(jobId) {
  return readDismissedCompletionJobIds().includes(jobId);
}
